// project imports
import Theme2 from './theme2';

// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

export default function Theme(colors, _presetColor, mode) {
  return Theme2(colors, mode);
}
